var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9165 33.832C39.2452 33.832 33.834 39.2411 33.834 45.9145C33.834 52.5865 39.2452 57.9978 45.9165 57.9978C52.5885 57.9978 57.9997 52.5865 57.9997 45.9145C57.9997 39.2411 52.5885 33.832 45.9165 33.832ZM53.1663 47.727H47.7289V53.1643H44.104V47.727H38.6667V44.1021H44.104V38.6647H47.7289V44.1021H53.1663V47.727Z",
    fill: "#007672"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7094 10.875H10.876V15.7084H15.7094V10.875Z",
    fill: "#007672"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4997 0H4.83441C2.17664 0 0.000976562 2.17566 0.000976562 4.83344V43.4987C0.000976562 46.1558 2.17664 48.3322 4.83441 48.3322H29.0001V45.9151C29.0001 36.589 36.59 28.9992 45.9161 28.9992H48.3332V4.83344C48.3332 2.17566 46.1568 0 43.4997 0ZM41.0834 10.8747H36.2499V15.7081H41.0834V19.333H36.2499V27.7906H27.7916V36.249H19.334V41.0824H15.7091V36.249H10.8757V41.0824H7.25077V7.24979H41.0834V10.8747Z",
    fill: "#007672"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7094 27.79H10.876V32.6235H15.7094V27.79Z",
    fill: "#007672"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1677 19.333H19.335V24.1657H24.1677V19.333Z",
    fill: "#007672"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7094 19.333H10.876V24.1657H15.7094V19.333Z",
    fill: "#007672"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1677 27.79H19.335V32.6235H24.1677V27.79Z",
    fill: "#007672"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6245 10.875H27.791V15.7084H32.6245V10.875Z",
    fill: "#007672"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1677 10.875H19.335V15.7084H24.1677V10.875Z",
    fill: "#007672"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6245 19.333H27.791V24.1657H32.6245V19.333Z",
    fill: "#007672"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppendIcon);
export default __webpack_public_path__ + "static/media/append-icon.6522bc430e3719d784a3ff19a0fc365a.svg";
export { ForwardRef as ReactComponent };